import React from 'react';
import { NetworkCard } from './NetworkCard';
import { EmptyState } from '../common/EmptyState';

export const NetworkGrid = ({ networks, useNameInUrl = false, useCodeInUrl = false }) => {
  if (!networks || networks.length === 0) {
    return <EmptyState message="No networks found" />;
  }

  return (
    <div className="row g-4">
      {networks.map((network, index) => (
        <div key={network.businessNetworkID} className="col-12 col-md-6 col-lg-4 col-xl-3">
          <NetworkCard
            network={network}
            index={index}
            useNameInUrl={useNameInUrl}
            useCodeInUrl={useCodeInUrl}
          />
        </div>
      ))}
    </div>
  );
};
